<h2 mat-dialog-title class="text-lg font-bold mb-1">
  Ventanas Horarias de Entrega
</h2>
<mat-dialog-content class="modal-content">
  <!-- Tabla de Colaboradores -->
  <div>
    <table class="min-w-500 overflow-y-visible mat-elevation-z">
      <thead>
        <tr>
          <th>#</th>
          <th>Horario</th>
          <th>Frecuencia</th>
          <th>Hrs. de entrega</th>
          <th>Estado</th>
          <th>
            <button *ngIf="!openFormAdd" mat-icon-button color="primary" (click)="openFormAdd = true" 
              matTooltip="Nuevo Registro">
              <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              <span></span>
            </button>
            <button *ngIf="openFormAdd" mat-icon-button color="primary" (click)="openFormAdd = false;resetFormAddListCollaborators()"
              matTooltip="Cerrar">
              <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="openFormAdd == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
          <td></td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button mat-button color="primary" (click)="openScheduleModal('create')" matTooltip="Horario">
                <mat-icon svgIcon="heroicons_solid:clock"></mat-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button mat-button color="primary" (click)="openFrecuencyModal('create')" matTooltip="Horario">
                <mat-icon svgIcon="heroicons_solid:calendar"></mat-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center">
              <mat-form-field class="mt-2 w-1/2"  appearance="fill" floatLabel="never">
                <input type="number" [(ngModel)]="currentCreateSubRouteDeliveryTimes.numberOfHoursToDelivery" matInput>
              </mat-form-field>
              
            </div>
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center">
              
            </div>
          </td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button color="primary" mat-icon-button (click)="onAddToListDeliveryTimes()">
                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngFor="let item of listCollaboratorsAdd; let i = index">
          <td valign="center">{{(i+1)}}</td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button mat-button color="primary" (click)="openScheduleModal('edit', item)" matTooltip="Horario" [disabled]="!item.isEditMode">
                <mat-icon svgIcon="heroicons_solid:clock"></mat-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button mat-button color="primary" (click)="openFrecuencyModal('edit', item)" matTooltip="Horario" [disabled]="!item.isEditMode">
                <mat-icon svgIcon="heroicons_solid:calendar" matBadge="{{item.days.length}}" matBadgeColor="primary" matBadgeSize="small"></mat-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center">
              <mat-form-field class="mt-2 w-1/2"  appearance="fill" floatLabel="never">
                <input type="number" [(ngModel)]="item.numberOfHoursToDelivery" matInput [disabled]="!item.isEditMode">
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="col-span-2 flex justify-center items-center">
              <mat-slide-toggle
                  [checked]="item.statusId === 1"
                  (change)="onStatusChange($event.checked, item)"
                  color="primary"
                  [disabled]="!item.isEditMode"
                >
                </mat-slide-toggle>
            </div>
          </td>
          <td>
            <div class="col-span-2" style="text-align:center">
              <button color="primary" mat-icon-button (click)="onUpdateDeliveryTime(item, i)" *ngIf="!item.isEditMode">
                <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
              </button>
              <button color="primary" mat-icon-button (click)="onSaveDeliveryTime(item, i)" *ngIf="item.isEditMode">
                <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
              </button>
              <button color="warn" mat-icon-button (click)="onDeleteDeliveryTime(item, i)">
                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-right">Aceptar</button>
</mat-dialog-actions>

<!-- <h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Colaborador" : "Agregar Colaborador" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <div class="col-span-2">
      <label for="group-select">Colaborador</label>
      <ng-select
        [(ngModel)]="currentCreateSubRouteCollaborator.masterUserId"
        [items]="userMasterList"
        bindLabel="username"
        bindValue="masterUserId"
        [searchable]="true"
        placeholder="Seleccione los clientes"
        name="businessPartnerId"
        required
        [appendTo]="'body'"
      >
      </ng-select>
    </div>
    <div class="col-span-2">
      <label for="group-select">Funcion de Cliente</label>
      <ng-select
        [(ngModel)]="currentCreateSubRouteCollaborator.businessPartnerFunctionId"
        [items]="businessPartnerFunctionList"
        bindLabel="name"
        bindValue="_id"
        [searchable]="true"
        placeholder="Seleccion Funcion de Socio"
        name="businessPartnerFunctionId"
        [appendTo]="'body'"
        required
      >
      </ng-select>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
 -->